<template>
  <div id="contenedor-contrato-catalogo-agregar-favorito">
    <v-form
      v-model="enviandoFormulario"
      ref="registrarNuevoCatalogoFavorito">
      <v-card>
        <v-card-title>
          Agregar concepto favorito
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-area
              v-model="favorito.nombreCorto"
              label="Nombre corto"
              :rules="[mixReglas.requerido]"
              rows="3"
              cols="12">
            </custom-text-area>
            <v-col
              cols="12"
              md="3">
              <custom-text-field
                v-model.number="favorito.orden"
                :rules="[mixReglas.requerido]"
                label="Orden">
              </custom-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarContratoCatalogoFavorito"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContartoCatalogoFavoritos from './mixContratoCatalogoFavoritos';

export default {
  name: 'AgregarContratoCatalogoFavorito',
  mixins: [mixContartoCatalogoFavoritos],
  components: {
    CustomButton,
    CustomTextArea,
    CustomTextField,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    concepto: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      favorito: {
        idContrato: this.idContrato,
        idConcepto: this.concepto.id,
        nombreCorto: this.concepto.concepto,
        orden: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevoCatalogoFavorito.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
